import { apiDelete, apiListAll, type MassnahmeCreate } from '@/core/api/resources'
import { composeMassnahmeSelection, splitMassnahmeSelection, findMassnahmeSelectionByNummer } from '@/core/lib/massnahme'
import { descriptionFor, subtypeFor } from '@/variants'
import { me, currentVariant } from './session'

export type MassnahmeRow = {
  id: string
  nummer: string
  bezeichnung: string

  durchf_form: string
  ue_anzahl: number | null
  kosten: string | null
  zeitl_umfang_woche: string | null
  start_zulassung: string | null
  ende_zulassung: string | null
  inhalt: string | null
  durchf_ort: string | null
  abschluss: string | null
  ziele_und_inhalt: string | null

  ansprechpartner: string | null
  anwesenheit_stichtag?: string
  aktivierung_zustaendig?: string | null
}

export function listMassnahmenFull(organisationId: string): Promise<MassnahmeRow[]> {
  return descriptionFor(currentVariant()).massnahmen.listMassnahmenFull(organisationId)
}

export type { MassnahmeCreate } from '@/core/api/resources'
export type MassnahmePatch = Partial<Omit<MassnahmeRow, 'id'>>

export function createMassnahme(
  organisationId: string,
  patch: MassnahmeCreate,
): Promise<MassnahmeRow> {
  return descriptionFor(currentVariant()).massnahmen.createMassnahme(organisationId, patch)
}

export function updateMassnahme(id: string, patch: MassnahmePatch): Promise<void> {
  return descriptionFor(currentVariant()).massnahmen.updateMassnahme(id, patch)
}

export async function deleteMassnahme(id: string): Promise<void> {
  await apiDelete('/massnahme/{id}', { id })
}

export type MassnahmeUeBudget = { ueAnzahl: number | null; label: string }

export async function getMassnahmeUeBudget(massnahmeId: string): Promise<MassnahmeUeBudget | null> {

  return subtypeFor(currentVariant()).getMassnahmeUeBudget(massnahmeId)
}

export type MassnahmeOption = { id: string; label: string; ue_anzahl: number }

export async function listMassnahmen(): Promise<MassnahmeOption[]> {
  const { organisationId, variant } = await me()
  return subtypeFor(variant).listMassnahmen(organisationId)
}

export type MassnahmeTbFields = {
  id: string
  zeitl_umfang: string
  ue_anzahl: number
}

export async function getMassnahmeTbFields(selection: string): Promise<MassnahmeTbFields | null> {
  const { organisationId, variant } = await me()

  const { nummer } = splitMassnahmeSelection(selection)

  return subtypeFor(variant).getMassnahmeTbFields(organisationId, nummer)
}

export async function getMassnahmeSelectionByNummer(nummer: string): Promise<string | null> {
  const { organisationId } = await me()
  const rows = await apiListAll('/massnahme', { organisation_id: organisationId })
  return findMassnahmeSelectionByNummer(
    nummer,
    rows.map((m) => composeMassnahmeSelection(String(m.nummer ?? ''), String(m.bezeichnung ?? ''))),
  )
}
